export default __webpack_public_path__ + "static/media/empty_m.513bfb37.jpeg";